import {
    GET_COMMON_ADDRESS_FAILURE, GET_COMMON_ADDRESS_REQUEST, GET_COMMON_ADDRESS_SUCCESS,
    POST_COMMON_ADDRESS_FAILURE, POST_COMMON_ADDRESS_REQUEST, POST_COMMON_ADDRESS_SUCCESS,
    UPDATE_COMMON_ADDRESS_FAILURE, UPDATE_COMMON_ADDRESS_REQUEST, UPDATE_COMMON_ADDRESS_SUCCESS,
    DELETE_COMMON_ADDRESS_FAILURE, DELETE_COMMON_ADDRESS_REQUEST, DELETE_COMMON_ADDRESS_SUCCESS
} from './types';

import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

export const getCommonAddress = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_COMMON_ADDRESS_REQUEST, GET_COMMON_ADDRESS_SUCCESS, GET_COMMON_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/common/addresses`,
      method: 'GET'
    }
  };
};

export const postCommonAddress = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_COMMON_ADDRESS_REQUEST, POST_COMMON_ADDRESS_SUCCESS, POST_COMMON_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/common/addresses`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateCommonAddress = (values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_COMMON_ADDRESS_REQUEST, UPDATE_COMMON_ADDRESS_SUCCESS, UPDATE_COMMON_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/common/addresses`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteCommonAddress = (id) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_COMMON_ADDRESS_REQUEST, DELETE_COMMON_ADDRESS_SUCCESS, DELETE_COMMON_ADDRESS_FAILURE],
      authenticated: true,
      endpoint: `api/common/addresses/${id}`,
      method: 'DELETE'
    }
  };
};
